import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';

export type FareType = 'dynamic_fare' | 'hourly_fare';

export type DateTimeStore = {
  expectedEndTime: number;
  fareType: FareType;
  startTime: number;
};

export const useDateTimeStore = create(
  devtools(
    combine(
      {
        expectedEndTime: 0,
        fareType: 'dynamic_fare',
        startTime: 0,
      } as DateTimeStore,
      (set) => ({
        setExpectedEndTime: (expectedEndTime: number) => {
          set({ expectedEndTime });
        },
        setStartTime: (startTime: number) => {
          set({ startTime });
        },
        setFareType: (fareType: FareType) => {
          set({ fareType });
        },
        resetDateTimeStore: () => {
          set({ expectedEndTime: 0, fareType: 'dynamic_fare', startTime: 0 });
        },
        setDateTimeStore: (value: DateTimeStore) => {
          set(value);
        },
      })
    )
  )
);
